/** Shape of a single `{ value, label }` entry served by `GET /api/enums/audit-outcomes`. */
export type LabeledValuePayload = {
	readonly value: string;
	readonly label: string;
};

export type AuditOutcomesFetchedPayload = LabeledValuePayload[];

export type AuditOutcomesFetchedAction = {
	type: 'AUDIT_OUTCOMES_FETCHED';
	payload: AuditOutcomesFetchedPayload;
};

export default (payload: AuditOutcomesFetchedPayload): AuditOutcomesFetchedAction => ({
	type: 'AUDIT_OUTCOMES_FETCHED',
	payload,
});
